import { PageButtonSchema } from '@/views/sports/components/PageButton/styles/PageButton.styles';

export const pageButtonStyles: PageButtonSchema = {
  button: {
    variant: 'unstyled',
    fontSize: '2xs',
    color: 'white',
    h: '20px',
    w: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    lineHeight: 'normal',
    bgGradient: 'transparent',
    textTransform: 'uppercase',
    fontFamily: 'accent',
    sx: {
      '&&': {
        fontWeight: 'bold',
      },
      svg: {
        bg: 'beta.300',
        p: '0.5',
        color: 'alpha.600',
        borderRadius: 'sm',
      },
    },
  },
};
